import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const searchGruposConteudo = term => {
  return api.http.get('/grupos_conteudo')
}

export const getSelectGruposConteudo = (term, callback) => {
  searchGruposConteudo(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/gruposConteudo.js